import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { AUTHENTICATED_ENTRY } from "configs/AppConfig";
import useLogin from "features/auth/login/store/useLogin";

const PublicRoute = () => {
  const storeLogin = useLogin();
  const { token } = useSelector((state) => state.auth);

  return storeLogin.user ? <Navigate to={AUTHENTICATED_ENTRY} /> : <Outlet />;
};

export default PublicRoute;
